<div class="bmc-bot-configuration">
    <div class="bmc-bot-configuration__title bz-flex bz-flex--spaced">
        <h4 class="bz-font-weight--semibold">{{ 'RPA_BOTS.RPA_CONFIGURATION' | translate }}</h4>
    </div>
    <h5 class="bz-space--stack-m">{{ 'RPA_BOTS.RPA_CONFIGURATION_DESCRIPTION' | translate }}</h5>
    <form #botConfigForm="ngForm" autocomplete="off">
        <div class="bz-flex bz-space--stack-m" *ngIf="type == 'automationAnywhere'">
            <bzg-input name="name" class="bmc-bot-configuration__input  bz-space--inline-m" [required]="true" [(ngModel)]="botDetail.displayName" [autocomplete]="'off'">
                {{ (type == 'automationAnywhere' ? 'RPA_BOTS.DISPLAY_NAME' : 'RPA_BOTS.TENANT_NAME') | translate }}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
            </bzg-input>
            <bzg-input #email1 name="email" class="bmc-bot-configuration__input" [required]="true" [(ngModel)]="botDetail.userName" [autocomplete]="'off'">
                {{ 'RPA_BOTS.USERNAME_EMAIL' | translate }}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
            </bzg-input>
        </div>
        <div class="bz-flex bz-space--stack-m" *ngIf="type != 'automationAnywhere'">
            <bzg-input name="name" class="bmc-bot-configuration__input  bz-space--inline-m" [required]="true" [(ngModel)]="botDetail.tenancyName" [autocomplete]="'off'">
                {{ (type == 'automationAnywhere' ? 'RPA_BOTS.DISPLAY_NAME' : 'RPA_BOTS.TENANT_NAME') | translate }}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
            </bzg-input>
            <bzg-input #email2 name="email" class="bmc-bot-configuration__input" [required]="true" [(ngModel)]="botDetail.userNameOrEmailAddress" [autocomplete]="'off'">
                {{ 'RPA_BOTS.USERNAME_EMAIL' | translate }}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
            </bzg-input>
        </div>
        <div class="bz-flex bz-space--stack-m">
            <bzg-password #password name="password" class="bmc-bot-configuration__input bz-space--inline-m" [required]="true" [(ngModel)]="botDetail.password" [autocomplete]="'off'">
                {{ 'GLOBAL.PASSWORD' | translate }}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
            </bzg-password>
            <bzg-input name="url" class="bmc-bot-configuration__input" [required]="true" [(ngModel)]="botDetail.server" [pattern]="URL_REGEXP" [autocomplete]="'off'">
                {{ (type == 'automationAnywhere' ? 'RPA_BOTS.BASE_URL' : 'RPA_BOTS.ORCHESTRATOR_URL') | translate }}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                <bzg-pattern-error>{{'GLOBAL.INVALID_URL' | translate}}</bzg-pattern-error>
            </bzg-input>
        </div>
        <div class="bz-flex bz-space--stack-m">
            <bzg-input readonly="true" name="version" class="bmc-bot-configuration__input  bz-space--stack-x1" [required]="true" [(ngModel)]="botDetail.version" [autocomplete]="'off'">
                {{ (type == 'automationAnywhere' ? 'RPA_BOTS.VERSION' : 'RPA_BOTS.VERSION') | translate }}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
            </bzg-input>
        </div>
        <div *ngIf="type=='automationAnywhere'" class="bmc-bot-configuration__content bz-flex bz-space--stack-m">
            <bzg-input name="callbackUrl" class="bmc-bot-configuration__input bz-space--inline-m" [required]="false" [(ngModel)]="botDetail.callbackUrl">
                {{ 'RPA_BOTS.CALLBACKURL' | translate }}
            </bzg-input> <span class="bmc-bot-configuration__span-callback">/api/rpa/automation/callback</span>
        </div>
    </form>
    <div class="bz-flex bz-flex--end bz-space--stack-l">
        <bzg-button-secondary class="bz-space--inline-m" (click)="onClearAll()">{{ 'RPA_BOTS.CLEAR_ALL' | translate }}</bzg-button-secondary>
        <bzg-button-primary (click)="onTestConnection()">{{ 'RPA_BOTS.TEST_CONNECTION' | translate }}</bzg-button-primary>
    </div>
</div>
<bot-processes-aae *ngIf="type == 'automationAnywhere'" [title]="'RPA_BOTS.AUTHOMATION_ANYWHERE_PROCESSES'" [bots]="botDetail.bots" [queues]="botDetail.queues"></bot-processes-aae>
<bot-processes *ngIf="type != 'automationAnywhere'" [title]="'RPA_BOTS.UIPATH_PROCESSES'" [botProcesses]="!botDetail.processes ? botDetail.queues : botDetail.processes"></bot-processes>
<div *ngIf="type != 'automationAnywhere'" class="bmc-bot-dashboard">
    <div class="bmc-bot-configuration__title bz-flex bz-flex--spaced">
        <h4 class="bz-font-weight--semibold">{{ 'RPA_BOTS.RPA_DASHBOARD' | translate }}</h4>
    </div>
    <div class="bz-flex bz-flex--end bz-space--stack-l">
        <bzg-button-secondary class="bz-space--inline-m" (click)="showCharts()">{{ 'RPA_BOTS.CHARTS' | translate }}
        </bzg-button-secondary>
        <bzg-button-secondary class="bz-space--inline-m" style="margin-right: 0;" (click)="showRetries()">
            {{ 'RPA_BOTS.RETRIES' | translate }}
        </bzg-button-secondary>
    </div>
</div>
<div class="bmc-bot-configuration__buttons">
    <bzg-button-primary [disabled]="!isValid()" (click)="onSave()">{{ 'GLOBAL.SAVE' | translate }}</bzg-button-primary>
</div>
<div *ngIf="chartsVisible" class="dashboard-tab">
    <bzg-button-icon class="close-button bz-font-weight--semibold" icon="icon-close-strong" size="l" (click)="closeCharts()"></bzg-button-icon>
    <biz-uipath-dashboard-wrapper></biz-uipath-dashboard-wrapper>
</div>
<div *ngIf="retriesVisible" class="dashboard-tab">
    <bzg-button-icon class="close-button bz-font-weight--semibold" icon="icon-close-strong" size="l" (click)="closeRetries()"></bzg-button-icon>
    <biz-uipath-retries-wrapper></biz-uipath-retries-wrapper>
</div>